import {dashboardStore} from "../store/dashboardPageStore";
import {useAppSelector} from "../../../redux/hooks";
import {useCallback} from "react";
import {DashboardTimeRangeOptionType} from "../store/IDashboardPageStore";

export interface IPlayingTimeDurationSwitcherLogic {
  changeSelectedRange: (selectRange: DashboardTimeRangeOptionType) => void;
  selectedRange: DashboardTimeRangeOptionType;
}

export const usePlayingTimeDurationSwitcherLogic = (): IPlayingTimeDurationSwitcherLogic => {
  const selectedRange = useAppSelector(dashboardStore.getPlayingTimeSelectedRange);
  const changeSelectedRange = useCallback((selectRange: DashboardTimeRangeOptionType) => {
    dashboardStore.setPlayingTimeRange(selectRange);
  }, []);
  return {
    selectedRange,
    changeSelectedRange,
  };
}
